import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';

export interface PostcodeDto {
  id?: number;
  postcode?: string;
  moo?: string;
  moobanName?: string;
  subdistrictCode?: string;
  districtCode?: string;
  subdistrictDisplay?: string;
  districtDisplay?: string;
  provinceDisplay?: string;
  checkedOutTime?: string;
  checkedOut?: number;
  createdId?: string;
  createdName?: string;
  createdDate?: string;
  lastUpdatedId?: string;
  lastUpdatedName?: string;
  lastUpdatedDate?: string;
}

@Injectable({providedIn: 'root'})
export class PostcodeService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/postcodes';

  search(page: number, size: number, search: string = ''): Observable<PageResponse<PostcodeDto>> {
    let params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size))
      .set('search', search);
    return this.http.get<PageResponse<PostcodeDto>>(this.apiUrl, {params});
  }

  getPostcodeById(id: number): Observable<PostcodeDto> {
    return this.http.get<PostcodeDto>(`${this.apiUrl}/${id}`);
  }

  createPostcode(postcode: PostcodeDto): Observable<PostcodeDto> {
    return this.http.post<PostcodeDto>(this.apiUrl, postcode);
  }

  updatePostcode(id: number, postcode: PostcodeDto): Observable<PostcodeDto> {
    return this.http.put<PostcodeDto>(`${this.apiUrl}/${id}`, postcode);
  }

  deletePostcode(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
